module.exports = __webpack_public_path__ + "static/chrislowell-bf50338f2b6639983e0f5208b773054d.jpg";